import Helper from './Helper';

class Search {
  constructor(config = {}) {
    const {
      closeButtonSelector,
      openButtonSelector,
      togglingContainerSelector
    } = config;
    this.closeButton = document.querySelector(closeButtonSelector);
    this.openButton = document.querySelector(openButtonSelector);
    this.togglingContainer = document.querySelector(togglingContainerSelector);
    this.body = document.querySelector('body');

    if(this.openButton){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.openButton.addEventListener('click', () => {
      Helper.addClass(this.togglingContainer, 'active');
      Helper.addClass(this.body, 'search-open');
      Helper.addClass(this.closeButton, 'search-active');
    });

    this.closeButton.addEventListener('click', () => {
      Helper.removeClass(this.togglingContainer, 'active');
      Helper.removeClass(this.body, 'search-open');
      Helper.removeClass(this.closeButton, 'search-active');
    });
  }

}

export default Search;
